import { store } from '@/apis';

export default {
  namespaced: true,
  state: {
    storeMap: {},
  },
  mutations: {
    fetchListByProductStart(state, productId) {
      state.storeMap = {
        ...state.storeMap,
        [productId]: [],
      };
    },
    fetchListByProductSuccess(state, {
      productId,
      data,
      storeIds,
      storeName,
    }) {
      if (storeIds && data.findIndex(item => item.id === Number(storeIds)) === -1) {
        data.unshift({ id: Number(storeIds), name: storeName || Number(storeIds) });
      }
      state.storeMap[productId] = data;
    },
  },
  actions: {
    async fetchListByProduct({
      commit,
    }, payload) {
      const { productId, storeIds = '', storeName = '' } = payload;
      if (storeIds) {
        delete payload.storeIds;
        delete payload.storeName;
      }
      let data = await store.fetchList(payload);
      if (payload && payload.pageNo > 1) {
        data = this.state.store.storeMap[productId].concat(data);
      }
      commit('fetchListByProductStart', productId);
      commit({
        type: 'fetchListByProductSuccess',
        productId,
        data,
        storeIds,
        storeName,
      });
    },
    async fetchListByYunCha({
      commit,
    }, payload) {
      const { productId } = payload;
      commit('fetchListByProductStart', productId);
      const data = await store.fetchListByYunCha(payload);
      commit({
        type: 'fetchListByProductSuccess',
        productId,
        data: (data || []).map(i => ({ storeId: i.id, storeName: i.storeName })),
      });
    },
  },
};
